import { Component, OnInit, Input , SimpleChanges, OnChanges } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import Spreadsheet, { Options as SpreadsheetOptions, SheetData } from "x-data-spreadsheet";
import { ShellExt } from "../../layout/shell/shell.component";
import { GetTableDto } from"../../layout/shell/shell.model";

@Component({
    selector: 'app-spreadsheetsource',
    templateUrl: './spreadsheetsource.component.html',
    standalone: false
})
export class SpreadSheetSourceComponent implements OnInit, OnChanges {
    @Input() signedUrl: string = '';
    @Input() rawFileData: GetTableDto = {};

    safeUrl: SafeResourceUrl = '';
    spreadsheetS3!: Spreadsheet;
    spreadSheetData: any = "";
    isImage = false;

    constructor(
        private sanitizer: DomSanitizer
    ){}

    ngOnInit(): void {
        this.changeSafeUrl();
        if(!this.signedUrl){
            this.spreadsheetS3 = this.initSpreadsheetS3();
            this.spreadsheetS3.loadData(this.spreadSheetData || {});
            if(this.rawFileData && this.rawFileData.data){
                const sheetsData = this.rawFileData.data.XSheets || this.rawFileData.data.APISheets;
                if (sheetsData) {
                    this.spreadsheetS3.loadData(sheetsData);
                }
            }
        }
    }

    changeSafeUrl() {
        if (!this.signedUrl) {
            this.safeUrl = '';
        } else {
            this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.signedUrl);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['signedUrl']) {
          this.changeSafeUrl();
        }
      }

    initSpreadsheetS3(): ShellExt {
        return new ShellExt("#x-spreadsheet-s3",{
            mode: "read",
            row: {
                len: 1000,
                height: 25,
              },
            col: {
            len: 100,
            width: 100,
            indexWidth: 60,
            minWidth: 60,
            },
            showToolbar: false,
            showBottomBar: false,
            style: {
                bgcolor: '#ffffff',
                align: 'left',
                valign: 'middle',
                textwrap: false,
                strike: false,
                underline: false,
                color: '#0a0a0a',
                font: {
                    // @ts-ignore
                    name: "proxima-nova",
                    size: 10,
                    bold: false,
                    italic: false
                }
            }
        });
    }
}
